import { render, staticRenderFns } from "./TrainingProgressModal.vue?vue&type=template&id=007dda36"
import script from "./TrainingProgressModal.vue?vue&type=script&lang=js"
export * from "./TrainingProgressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports